<div id="annotation-window">
  <video
    *ngIf="fileUrl"
    #videoRef
    (timeupdate)="resetVideoTime()"
    (ended)="videoEnded()"
    (loadedmetadata)="initializeVideo()"
    (timeupdate)="updateTimeElapsed()"
    (timeupdate)="updateProgress()"
    (volumechange)="updateVolumeIcon()"
    (click)="playVideo()"
  >
    <source [src]="fileUrl" type="video/mp4" />
  </video>
  <div id="konva-holder"></div>
</div>
<div>
  <div class="video-progress">
    <progress id="progress-bar" value="0" min="0" #progressBar></progress>
    <input class="seek" id="seek" value="0" min="0" type="range" step=".1" #seek (mousemove)="updateSeekTooltip($event)" (input)="skipAhead($event)" />
    <div class="seek-tooltip" id="seek-tooltip" #seekTooltip>00:00</div>
  </div>
</div>
<div class="text-center flex items-center justify-between">
  <div class="flex flex-col text-sm text-gray-600">
    <div>
      <time id="time-elapsed" #timeElapsed>00:00</time>
      <span> / </span>
      <time id="duration" #duration>00:00</time>
      <br />
      <span *ngIf="playBackSpeed !== 1"> ({{ playBackSpeed }}x)</span>
    </div>
  </div>
  <div class="flex justify-end text-gray-700">
    <button mat-icon-button (click)="setPlaybackSpeed(-1)" matTooltip="Decrease speed by 0.25x">
      <mat-icon class="material-icons-outlined" style="transform: scaleX(-1)">speed</mat-icon>
    </button>
    <button mat-icon-button (click)="jumpVideo(5, 'backward')" matTooltip="5 sec backward">
      <mat-icon class="material-icons-outlined">replay_5</mat-icon>
    </button>
    <button mat-icon-button (click)="playVideo()">
      <mat-icon class="material-icons-outlined" *ngIf="!isVideoPlaying">play_circle</mat-icon>
      <mat-icon class="material-icons-outlined" *ngIf="isVideoPlaying">pause_circle</mat-icon>
    </button>
    <button mat-icon-button (click)="jumpVideo(5, 'forward')" matTooltip="5 sec forward">
      <mat-icon class="material-icons-outlined">forward_5</mat-icon>
    </button>
    <button mat-icon-button (click)="setPlaybackSpeed(1)" matTooltip="Increase speed by 0.25x">
      <mat-icon class="material-icons-outlined">speed</mat-icon>
    </button>
  </div>
  <div class="flex justify-end text-gray-700">
    <div>
      <button mat-icon-button class="fullscreen-button" id="fullscreen-button" #fullscreenButton i18n-matTooltip matTooltip="Expand asset" (click)="toggleFullScreen()">
        <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
      </button>
    </div>
    <div class="volume-controls relative">
      <button mat-icon-button class="volume-button" #volumeButton id="volume-button" i18n-matTooltip matTooltip="Set volume" (click)="toggleMute()">
        <mat-icon class="material-icons-outlined">{{ volumeIcon }}</mat-icon>
      </button>
      <input class="volume -rotate-90 absolute -top-14 -left-8" id="volume" #volume value="1" type="range" max="1" min="0" step="0.01" (input)="updateVolume()" />
    </div>
  </div>
</div>
